import * as R from 'ramda';

const notEquals = R.complement(R.equals);

const checkIfGroup = R.compose(
	R.when(notEquals(false), R.is(Array)),
	R.pathOr(false, [0])
);

function findInGroup(selectedPropName, item, data) {
	const [index] = R.reduceWhile(
		([foundIndex, index]) => foundIndex === -1,
		([foundIndex, index], group) => {
			return group.findIndex(
				R.propEq(selectedPropName, item[selectedPropName]),
				group
			) > -1
				? [index, index + 1]
				: [-1, index + 1];
		},
		[-1, 0],
		data
	);
	return index;
}

export { notEquals, checkIfGroup, findInGroup };
